import { createContext, ReactNode, useContext, useState } from 'react'

interface SidebarContextType {
  isMinimized: boolean
  isMobileSidebarOpen: boolean
  toggleSidebar: () => void
  setSidebarMinimized: (minimized: boolean) => void
  setMobileSidebarOpen: (open: boolean) => void
  closeMobileSidebar: () => void
}

const SidebarContext = createContext<SidebarContextType | undefined>(undefined)

export function SidebarProvider({ children }: { children: ReactNode }) {
  const [isMinimized, setIsMinimized] = useState(false)
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false)

  const toggleSidebar = () => {
    setIsMinimized(!isMinimized)
  }

  const setSidebarMinimized = (minimized: boolean) => {
    setIsMinimized(minimized)
  }

  const setMobileSidebarOpen = (open: boolean) => {
    setIsMobileSidebarOpen(open)
  }

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false)
  }

  return (
    <SidebarContext.Provider
      value={{
        isMinimized,
        isMobileSidebarOpen,
        toggleSidebar,
        setSidebarMinimized,
        setMobileSidebarOpen,
        closeMobileSidebar,
      }}
    >
      {children}
    </SidebarContext.Provider>
  )
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}
